export enum PRODUCTS_NAME {
  MEMBERSHIP_ESSENTIAL_ANNUALLY = "membership_essential_19_99_eur_annually",
  MEMBERSHIP_ESSENTIAL_SINGLE = "membership_essential_19_99_eur_single",
  MEMBERSHIP_COMPLETE_ANNUALLY = "membership_complete_49_99_eur_annually",
  MEMBERSHIP_COMPLETE_SINGLE = "membership_complete_49_99_eur_single",
  AIR_BUNDLE_MEMBERSHIP_ESSENTIAL_ANNUALLY = "membership_essential_24_99_eur_annually",
  AIR_BUNDLE_MEMBERSHIP_ESSENTIAL_SINGLE = "membership_essential_24_99_eur_single",
  AIR_BUNDLE_MEMBERSHIP_COMPLETE_ANNUALLY = "membership_complete_64_99_eur_annually",
  AIR_BUNDLE_MEMBERSHIP_COMPLETE_SINGLE = "membership_complete_64_99_eur_single",
  UPGRADE_TO_TRIP_COMPLETE = "upgrade_to_trip_complete",
}
